import React, { useEffect } from 'react'

//context
import { useContext, useState } from 'react'
//character context
import { CharacterContext } from '../../../contexts/character'
import { DBContext } from '../../../contexts/databases'
//language
import language from '../../../data/language.json'

import Select from 'react-select'

//Job Ids
import * as jobId from '../../../data/jobID'

function JobSelect(props) {
	const { job, changeJob } = useContext(CharacterContext)
	const { setCurrentJob } = useContext(DBContext)
	const onJobChange = (event) => {
		changeJob(event.value)
	}

	const [selectedValue, setSelectedValue] = useState([
		{
			label: language[props.language].jobName.NOVICE,
			value: jobId.NOVICE,
		},
	])

	const jobsOptions = [
		{
			label: 'Novice',
			options: [
				{
					label: language[props.language].jobName.NOVICE,
					value: jobId.NOVICE,
				},
			],
		},
		{
			label: '1st Job',
			options: [
				{
					label: language[props.language].jobName.SWORDMAN,
					value: jobId.SWORDMAN,
				},
				{
					label: language[props.language].jobName.THIEF,
					value: jobId.THIEF,
				},
				{
					label: language[props.language].jobName.ACOLYTE,
					value: jobId.ACOLYTE,
				},
				{
					label: language[props.language].jobName.ARCHER,
					value: jobId.ARCHER,
				},
				{
					label: language[props.language].jobName.MAGE,
					value: jobId.MAGE,
				},
				{
					label: language[props.language].jobName.MERCHANT,
					value: jobId.MERCHANT,
				},
			],
		},
		{
			label: '2nd Job',
			options: [
				{
					label: language[props.language].jobName.KNIGHT,
					value: jobId.KNIGHT,
				},
				{
					label: language[props.language].jobName.ASSASSIN,
					value: jobId.ASSASSIN,
				},
				{
					label: language[props.language].jobName.PRIEST,
					value: jobId.PRIEST,
				},
				{
					label: language[props.language].jobName.HUNTER,
					value: jobId.HUNTER,
				},
				{
					label: language[props.language].jobName.WIZARD,
					value: jobId.WIZARD,
				},
				{
					label: language[props.language].jobName.BLACKSMITH,
					value: jobId.BLACKSMITH,
				},
				{
					label: language[props.language].jobName.CRUSADER,
					value: jobId.CRUSADER,
				},
				{
					label: language[props.language].jobName.ROGUE,
					value: jobId.ROGUE,
				},
				{
					label: language[props.language].jobName.MONK,
					value: jobId.MONK,
				},
				{
					label: language[props.language].jobName.BARD,
					value: jobId.BARD,
				},
				{
					label: language[props.language].jobName.DANCER,
					value: jobId.DANCER,
				},
				{
					label: language[props.language].jobName.SAGE,
					value: jobId.SAGE,
				},
				{
					label: language[props.language].jobName.ALCHEMIST,
					value: jobId.ALCHEMIST,
				},
			],
		},
		{
			label: 'Super Novice',
			options: [
				{
					label: language[props.language].jobName.SUPER_NOVICE,
					value: jobId.SUPER_NOVICE,
				},
				{
					label: language[props.language].jobName.SUPER_NOVICE_E,
					value: jobId.SUPER_NOVICE_E,
				},
			],
		},
		{
			label: 'Transcended Novice',
			options: [
				{
					label: language[props.language].jobName.NOVICE_HIGH,
					value: jobId.NOVICE_HIGH,
				},
			],
		},
		{
			label: 'Transcended 1st Job',
			options: [
				{
					label: language[props.language].jobName.SWORDMAN_HIGH,
					value: jobId.SWORDMAN_HIGH,
				},
				{
					label: language[props.language].jobName.THIEF_HIGH,
					value: jobId.THIEF_HIGH,
				},
				{
					label: language[props.language].jobName.ACOLYTE_HIGH,
					value: jobId.ACOLYTE_HIGH,
				},
				{
					label: language[props.language].jobName.ARCHER_HIGH,
					value: jobId.ARCHER_HIGH,
				},
				{
					label: language[props.language].jobName.MAGE_HIGH,
					value: jobId.MAGE_HIGH,
				},
				{
					label: language[props.language].jobName.MERCHANT_HIGH,
					value: jobId.MERCHANT_HIGH,
				},
			],
		},
		{
			label: 'Transcended 2nd Job',
			options: [
				{
					label: language[props.language].jobName.LORD_KNIGHT,
					value: jobId.LORD_KNIGHT,
				},
				{
					label: language[props.language].jobName.ASSASSIN_CROSS,
					value: jobId.ASSASSIN_CROSS,
				},
				{
					label: language[props.language].jobName.HIGH_PRIEST,
					value: jobId.HIGH_PRIEST,
				},
				{
					label: language[props.language].jobName.SNIPER,
					value: jobId.SNIPER,
				},
				{
					label: language[props.language].jobName.HIGH_WIZARD,
					value: jobId.HIGH_WIZARD,
				},
				{
					label: language[props.language].jobName.WHITESMITH,
					value: jobId.WHITESMITH,
				},
				{
					label: language[props.language].jobName.PALADIN,
					value: jobId.PALADIN,
				},
				{
					label: language[props.language].jobName.STALKER,
					value: jobId.STALKER,
				},
				{
					label: language[props.language].jobName.CHAMPION,
					value: jobId.CHAMPION,
				},
				{
					label: language[props.language].jobName.CLOWN,
					value: jobId.CLOWN,
				},
				{
					label: language[props.language].jobName.GYPSY,
					value: jobId.GYPSY,
				},
				{
					label: language[props.language].jobName.PROFESSOR,
					value: jobId.PROFESSOR,
				},
				{
					label: language[props.language].jobName.CREATOR,
					value: jobId.CREATOR,
				},
			],
		},
		{
			label: 'Transcended 3rd Job',
			options: [
				{
					label: language[props.language].jobName.RUNE_KNIGHT_T,
					value: jobId.RUNE_KNIGHT_T,
				},
				{
					label: language[props.language].jobName.GUILLOTINE_CROSS_T,
					value: jobId.GUILLOTINE_CROSS_T,
				},
				{
					label: language[props.language].jobName.ARCH_BISHOP_T,
					value: jobId.ARCH_BISHOP_T,
				},
				{
					label: language[props.language].jobName.RANGER_T,
					value: jobId.RANGER_T,
				},
				{
					label: language[props.language].jobName.WARLOCK_T,
					value: jobId.WARLOCK_T,
				},
				{
					label: language[props.language].jobName.MECHANIC_T,
					value: jobId.MECHANIC_T,
				},
				{
					label: language[props.language].jobName.ROYAL_GUARD_T,
					value: jobId.ROYAL_GUARD_T,
				},
				{
					label: language[props.language].jobName.SHADOW_CHASER_T,
					value: jobId.SHADOW_CHASER_T,
				},
				{
					label: language[props.language].jobName.SURA_T,
					value: jobId.SURA_T,
				},
				{
					label: language[props.language].jobName.MINSTREL_T,
					value: jobId.MINSTREL_T,
				},
				{
					label: language[props.language].jobName.WANDERER_T,
					value: jobId.WANDERER_T,
				},
				{
					label: language[props.language].jobName.SORCERER_T,
					value: jobId.SORCERER_T,
				},
				{
					label: language[props.language].jobName.GENETIC_T,
					value: jobId.GENETIC_T,
				},
			],
		},
		{
			label: 'Non-Transcended 3rd Job',
			options: [
				{
					label: language[props.language].jobName.RUNE_KNIGHT,
					value: jobId.RUNE_KNIGHT,
				},
				{
					label: language[props.language].jobName.GUILLOTINE_CROSS,
					value: jobId.GUILLOTINE_CROSS,
				},
				{
					label: language[props.language].jobName.ARCH_BISHOP,
					value: jobId.ARCH_BISHOP,
				},
				{
					label: language[props.language].jobName.RANGER,
					value: jobId.RANGER,
				},
				{
					label: language[props.language].jobName.WARLOCK,
					value: jobId.WARLOCK,
				},
				{
					label: language[props.language].jobName.MECHANIC,
					value: jobId.MECHANIC,
				},
				{
					label: language[props.language].jobName.ROYAL_GUARD,
					value: jobId.ROYAL_GUARD,
				},
				{
					label: language[props.language].jobName.SHADOW_CHASER,
					value: jobId.SHADOW_CHASER,
				},
				{
					label: language[props.language].jobName.SURA,
					value: jobId.SURA,
				},
				{
					label: language[props.language].jobName.MINSTREL,
					value: jobId.MINSTREL,
				},
				{
					label: language[props.language].jobName.WANDERER,
					value: jobId.WANDERER,
				},
				{
					label: language[props.language].jobName.SORCERER,
					value: jobId.SORCERER,
				},
				{
					label: language[props.language].jobName.GENETIC,
					value: jobId.GENETIC,
				},
			],
		},
		{
			label: 'Expanded 1st Job',
			options: [
				{
					label: language[props.language].jobName.TAEKWON,
					value: jobId.TAEKWON,
				},
				{
					label: language[props.language].jobName.NINJA,
					value: jobId.NINJA,
				},
				{
					label: language[props.language].jobName.GUNSLINGER,
					value: jobId.GUNSLINGER,
				},
			],
		},
		{
			label: 'Expanded 2nd Job',
			options: [
				{
					label: language[props.language].jobName.STAR_GLADIATOR,
					value: jobId.STAR_GLADIATOR,
				},
				{
					label: language[props.language].jobName.SOUL_LINKER,
					value: jobId.SOUL_LINKER,
				},
				{
					label: language[props.language].jobName.KAGEROU,
					value: jobId.KAGEROU,
				},
				{
					label: language[props.language].jobName.OBORO,
					value: jobId.OBORO,
				},
				{
					label: language[props.language].jobName.REBELLION,
					value: jobId.REBELLION,
				},
			],
		},
		{
			label: 'Expanded 3rd Job',
			options: [
				{
					label: language[props.language].jobName.STAR_EMPEROR,
					value: jobId.STAR_EMPEROR,
				},
				{
					label: language[props.language].jobName.SOUL_REAPER,
					value: jobId.SOUL_REAPER,
				},
			],
		},
		{
			label: 'Doram',
			options: [
				{
					label: language[props.language].jobName.SUMMONER,
					value: jobId.SUMMONER,
				},
			],
		},
	]

	useEffect(() => {
		setCurrentJob(job & ~jobId.IS_MALE) //remove male/female part of job ID
		let newJob = findJobOptionByValue(jobsOptions, job)

		if (newJob) setSelectedValue(newJob)
		else {
			console.log('job not found')
			setSelectedValue([
				{
					label: language[props.language].jobName[
						jobId.getClassName(job)
					],
					value: job,
				},
			])
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [job])

	return (
		<Select
			value={selectedValue}
			styles={props.customStyles}
			id={props.id}
			className='Job'
			onChange={onJobChange}
			options={jobsOptions}
		/>
	)
}

function findJobOptionByValue(jobsOptions, valueToFind) {
	for (const group of jobsOptions) {
		const found = group.options.find((opt) => opt.value === valueToFind)
		if (found) {
			return found
		}
	}
	return null
}
export default JobSelect
